/**
 * platformBaseUrl — fuente ÚNICA del dominio público oficial de la plataforma
 * para el frontend. Lo sirve el backend (GET /api/public/platform-base-url, que
 * lee FRONTEND_URL vía public_base_url()), así que SIEMPRE coincide con el
 * redirect_uri/callbacks que el backend usa por detrás (cero drift, match OAuth).
 *
 * Uso: para URLs que se MUESTRAN/COPIAN para pegar en servicios externos
 * (redirect_uri OAuth, webhooks de proveedores, instrucciones CNAME). NO usar
 * window.location.origin ahí (en app.dealider.com no coincidiría con el backend).
 *
 * El fetch se cachea a nivel módulo → una sola llamada de red por sesión,
 * reutilizada por todas las pantallas.
 */
import { useState, useEffect } from 'react';
import api from '@/lib/api';

let _cache = null;      // string ya resuelto (base_url)
let _promise = null;    // fetch en vuelo

export async function getPlatformBaseUrl() {
  if (_cache !== null) return _cache;
  if (!_promise) {
    _promise = api
      .get('/public/platform-base-url')
      .then((r) => {
        _cache = (r.data && r.data.base_url) || '';
        return _cache;
      })
      .catch(() => {
        _promise = null; // permite reintentar en el próximo consumidor
        return '';
      });
  }
  return _promise;
}

/** Hook: devuelve el dominio oficial ("" mientras carga o si FRONTEND_URL falta). */
export function usePlatformBaseUrl() {
  const [base, setBase] = useState(_cache || '');
  useEffect(() => {
    let mounted = true;
    getPlatformBaseUrl().then((v) => {
      if (mounted) setBase(v);
    });
    return () => {
      mounted = false;
    };
  }, []);
  return base;
}
